import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const issuesAppBuilder = DataRouterApplicationBuilder.create('issues')
